import {CustomEventsStore} from 'common/report/stores/custom-events';
import {contextify} from 'common/util/react';

const context = contextify<CustomEventsStore>();

export const CustomEventsProvider = context.Provider;
export const CustomEventsConsumer = context.Consumer;
export const useCustomEvents = context.hook;
